const MuiLink = {
  defaultProps: {
    underline: 'none'
  },
  styleOverrides: {
    root: ({
      theme
    }) => ({
      fontSize: theme.typography.pxToRem(16)
    })
  }
};
export default MuiLink;